import './YearPicker.scss';

import { useMemo, useState } from 'react';

type Props = {
  value: string;
  onChange: (year: number) => void;
};

export default function YearPicker({ value, onChange }: Props) {
  const [startYear, setStartYear] = useState(() => {
    return Number(value) - (Number(value) % 4);
  });

  const years = useMemo(
    () => Array.from({ length: 4 }, (_, i) => startYear + i),
    [startYear]
  );

  return (
    <div className="year-picker-row">
      <button
        className="nav-btn"
        onClick={() => setStartYear((prev) => prev - 4)}
      >
        ‹
      </button>

      <div className="year-list">
        {years.map((year) => (
          <div
            key={year}
            className={`year-item ${year === Number(value) ? 'active' : ''}`}
            onClick={() => onChange(year)}
          >
            {year}
          </div>
        ))}
      </div>

      <button
        className="nav-btn"
        onClick={() => setStartYear((prev) => prev + 4)}
      >
        ›
      </button>
    </div>
  );
}
